import { useEffect, useState } from "react";

import { addNMinutes, roundToMinutes } from "../../utils/utils";

export default function useWallboxLockTime(
  wallbox,
  addLockTime,
  showMsg = null,
  isFocused = true,
) {
  const [currentLockTime, setCurrentLockTime] = useState({
    locked: false,
    datetime: roundToMinutes(addNMinutes(new Date(), 60), 15),
  });

  const loadData = () => {
    setCurrentLockTime({
      locked: false,
      datetime: roundToMinutes(addNMinutes(new Date(), 60), 15),
    });
  };

  const initData = loadData;

  const clearData = () => {};

  useEffect(() => {
    if (isFocused) initData();
    else clearData();
  }, [isFocused]);

  const _setDate = (d1, d2) => {
    if (!d2) return d1;
    const date = new Date(d1);
    date.setFullYear(d2.getFullYear(), d2.getMonth(), d2.getDate());
    return date;
  };

  const _setTime = (d1, d2) => {
    if (!d2) return d1;
    const date = new Date(d1);
    date.setHours(d2.getHours(), d2.getMinutes(), 0, 0);
    return date;
  };

  const addCurrentTime = async (onSuccess) => {
    const locked = currentLockTime.locked;
    const datetime = currentLockTime.datetime;
    if (datetime < new Date()) {
      showMsg?.("Datum liegt in der Vergangenheit", "error");
      return;
    }
    await addLockTime(locked, datetime);
    onSuccess?.();
  };

  const lockTimes = wallbox._lock_times || [];
  const addDisabled =
    currentLockTime.locked == null || currentLockTime.datetime == null;

  const setLocked = (locked) => setCurrentLockTime((c) => ({ ...c, locked }));

  const setDate = (date) =>
    setCurrentLockTime((c) => ({
      ...c,
      datetime: _setDate(c.datetime, date),
    }));

  const setTime = (time) =>
    setCurrentLockTime((c) => ({
      ...c,
      datetime: _setTime(c.datetime, time),
    }));

  const setDatetime = (datetime) =>
    setCurrentLockTime((c) => ({
      ...c,
      datetime,
    }));

  return {
    lockTimes,
    add: { run: addCurrentTime, disabled: addDisabled },
    datetime: {
      value: currentLockTime.datetime,
      setvalue: setDatetime,
      setDate,
      setTime,
    },
    locked: { value: currentLockTime.locked, setValue: setLocked },
    data: { init: initData, update: loadData, clear: clearData },
  };
}
